import React from 'react';
import * as LucideIcons from 'lucide-react';
import { LucideProps, HelpCircle, Package } from 'lucide-react';

interface DynamicIconProps extends Omit<LucideProps, 'name'> {
  name: string | null | undefined;
}

const DynamicIcon: React.FC<DynamicIconProps> = ({ name, ...props }) => {
  // 1. Handle if name is null, undefined, or an empty string
  if (!name) {
    return <Package {...props} />;
  }

  // 2. Resolve icon from library
  const IconComponent = (LucideIcons as any)[name];

  // 3. Fallback if string doesn't match a Lucide icon name
  if (!IconComponent) {
    return <HelpCircle {...props} />;
  }

  return <IconComponent {...props} />;
};

export default DynamicIcon;